import { render, staticRenderFns } from "./MRMarket.vue?vue&type=template&id=a99c4876"
import script from "./MRMarket.vue?vue&type=script&lang=js"
export * from "./MRMarket.vue?vue&type=script&lang=js"
import style0 from "./MRMarket.vue?vue&type=style&index=0&id=a99c4876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports